export const DEFAULT_WAITING_MESSAGE = {
  title: 'Hold on',
  subtext: 'Connecting you to a doctor shortly',
};

export const NO_DOCTOR_MESSAGE = {
  title: 'Our Doctors Are Busy',
  subtext:
    'Looks like all doctors are currently with other patients. Would you like us to call you back?',
};

export const TAKING_TO_LONG_MESSAGE = {
  title: 'Hmmm :/',
  subtext:
    'Looks like this is taking longer than expected, would you like to request a callback?',
};

export const onlineUserPollingTime = 1500;
export const checkCallStatusTime = 5000;
export const checkUserAloneInCallTime = 15000;

export const REQUEST_A_CALL_BACK = {
  title: 'Request a call-back',
  subtext: 'An available TruDoc doctor will contact you within 30 minutes.',
};

export const CALLBACK = {
  title: 'Let Us Reach You',
  subtext:
    'Share your concern, and a TruDoc doctor will contact within 30 min.',
};

export const REQUEST_RECEIVED = {
  title: 'Request Received',
  subtext:
    ' Your request has been submitted successfully. One of our doctors will get back to you shortly.',
  ticketId: 'Ticket ID:',
  copied: 'Copied ✔',
  note: 'Please save this id for future reference or take a screenshot.',
};
